function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.996,
    height: 16.109,
    viewBox: "0 0 5.291 4.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.055 7.406v15.59a1 1 0 0 1-2 0V7.406l-5.3 5.3a1 1 0 1 1-1.4-1.42l7-7a1 1 0 0 1 1.4 0l7 7a1 1 0 1 1-1.4 1.42l-5.3-5.31Z",
    transform: "matrix(0 .26458 -.26458 0 6.349 -1.588)",
    style: {
      fill: "#00caff",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowPositive);
export default __webpack_public_path__ + "static/media/right-arrow-positive.85a8e4c19b9f286a8d3f33a853d2746d.svg";
export { ForwardRef as ReactComponent };